import { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
// // import toast, { ToastContainer } from 'react-toastify'; // Importing the default export
// // import 'react-toastify/dist/ReactToastify.css'; // Importing CSS separately if needed

import { useNavigate, useParams } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/helpers";



/**
 * AddBankAccount component provides a form for users to add their bank account details.
 * Handles validation, navigation, and form submission logic.
 */
const AddBankAccount = ({ login = null }) => {
  const { userId } = useParams();
  const [errorMessages] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [redirectUrl] = useState(login ? 'customer' : 'customerCard')
  const validationSchema = Yup.object().shape({
    name_at_bank: Yup.string()
      .matches(
        /^[a-zA-Z\s]+$/,
        "Name at Bank should contain only alphabets and spaces"
      )
      .required("Name at Bank is required"),

    account_number: Yup.string()
      .matches(/^[0-9]+$/, "Account Number should contain only numbers")
      .required("Account Number is required"),

    re_enter_account_number: Yup.string()
      .required("Re-enter Account Number is required")
      .oneOf([Yup.ref("account_number"), null], "Account Numbers must match"),

    ifsc_code: Yup.string()
      .matches(
        /^[a-zA-Z0-9]+$/,
        "IFSC Code should contain only alphabets and numbers"
      )
      .required("IFSC Code is required"),
  });

  const handleEditClick = () => {
    // Navigate back to the previous page
    navigate(-1);
  };

  const formik = useFormik({
    initialValues: {
      user_id: "",
      name_at_bank: "",
      account_number: "",
      re_enter_account_number: "",
      ifsc_code: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setIsLoading(true); // Set loading to true before API call

        let item = {
          user_id: userId,
          name: values.name_at_bank,
          account_number: values.account_number,
          re_enter_account_number: values.re_enter_account_number,
          ifsc_code: values.ifsc_code,
        };

        navigate(`/${redirectUrl}/reconfirm-details/${userId}`, {
          state: {
            // bankdetails: apiResponseData?.original?.data?.data,
            enteredValue: item,
            userId: userId,
          },
        });

      } catch (error) {
        // Display error toast
        // alert("Failed to save bank details");
      } finally {
        setIsLoading(false); // Set loading to false after API call
      }
    },
  });

  return (
    <>
      <div className="container mt-4">
        <div className="row align-items-center">
          <div className="col-12 col-md-12 col-lg-5">
            <div className="text-center mb-3">
              <img
                width="40%"
                alt="icon"
                src={toAbsoluteUrl("/media/images/Bank-Upload-min.png")}
              />
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-7">
            <h1 className="mb-5">Add Bank Detail</h1>
            <p className="grey-text">Enter your bank account details below.</p>

            <form className="mt-10 kyc_user" onSubmit={formik.handleSubmit}>
              <div className="form-group">
                <label>Name at Bank</label>
                <input
                  type="text"
                  name="name_at_bank"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name_at_bank}
                  className="form-control"
                  placeholder="Enter"
                />
                <div className="error-messages">
                  {formik.touched.name_at_bank &&
                    formik.errors.name_at_bank && (
                      <p className="text-danger">
                        {formik.errors.name_at_bank}
                      </p>
                    )}
                </div>
              </div>

              <div className="form-group">
                <label>Account Number</label>
                <input
                  type="text"
                  name="account_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.account_number}
                  className="form-control"
                  placeholder="Enter"
                />
                <div className="error-messages">
                  {formik.touched.account_number &&
                    formik.errors.account_number && (
                      <p className="text-danger">
                        {formik.errors.account_number}
                      </p>
                    )}
                </div>
              </div>

              <div className="form-group">
                <label>Re-enter Account Number</label>
                <input
                  type="text"
                  name="re_enter_account_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.re_enter_account_number}
                  className="form-control"
                  placeholder="Enter"
                />
                <div className="error-messages">
                  {formik.touched.re_enter_account_number &&
                    formik.errors.re_enter_account_number && (
                      <p className="text-danger">
                        {formik.errors.re_enter_account_number}
                      </p>
                    )}
                </div>
              </div>

              <div className="form-group">
                <label>IFSC Code</label>
                <input
                  type="text"
                  name="ifsc_code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ifsc_code}
                  className="form-control"
                  placeholder="Enter"
                />
                <div className="error-messages">
                  {formik.touched.ifsc_code && formik.errors.ifsc_code && (
                    <p className="text-danger">{formik.errors.ifsc_code}</p>
                  )}
                </div>
              </div>

              <div className="btns cn-btn mt-10 mb-5 d-flex">
                <button
                  className="btn bgdark-blue text-white"
                  onClick={handleEditClick}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="btn red-btn text-white"
                  style={{
                    backgroundColor: isLoading ? "#999" : "red-btn text-white",
                    color: "white",
                    cursor: isLoading ? "not-allowed" : "pointer",
                  }}
                  disabled={formik.isSubmitting}
                >
                  {formik.isSubmitting ? "Submitting..." : "Next"}
                </button>
              </div>
              <div className="error-messages">
                {errorMessages && (
                  <>{errorMessages.message && <p>{errorMessages.message}</p>}</>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* <ToastContainer />   */}
    </>
  );
};

export default AddBankAccount;
